export const ruTranslations = {
  langSwitcher: {
    aria: 'Сменить язык',
    ru: 'Русский',
    en: 'English',
  },

  nav: {
    allTools: 'Все инструменты',
    blog: 'Блог',
  },

  badge: {
    local: 'Локально',
    server: 'На сервере',
    localFirst: 'Локально*',
    localTitle: 'Текст обрабатывается прямо в браузере и не отправляется на сервер',
    serverTitle: 'Текст отправляется на сервер для обработки',
    localFirstTitle:
      'По умолчанию обработка происходит в браузере. При необходимости доступна серверная опция.',
  },

  common: {
    textTools: 'Инструменты',
    goToTool: 'Открыть',
    scenarios: 'Сценарии',
    howTo: 'Как пользоваться',
    faq: 'Вопросы',
    otherTools: 'Другие инструменты',
    allTools: 'Все инструменты',
    relatedTools: 'Связанные инструменты',
    updated: 'Обновлено',
    allBlogPosts: 'Все записи блога',
  },

  hero: {
    title: 'Инструменты разработчика онлайн',
    description:
      'JSON, YAML, Base64, UUID, cron и другое прямо в браузере. Без регистрации и отправки данных на сервер.',
  },

  catalog: {
    title: 'Каталог инструментов',
    allJobs: 'Все задачи',
    searchLabel: 'Найти инструмент',
    searchPlaceholder: 'Найти JSON, cron, Base64...',
    enterHint: 'Enter — открыть',
    frequent: 'Часто используют',
    resultCount: 'Найдено: {count}',
    reset: 'Сбросить',
    noMatchTitle: 'Ничего не найдено',
    noMatchDescription: 'Измените запрос или сбросьте фильтр задачи.',
  },

  notFound: {
    eyebrow: '404: страница не найдена',
    title: 'Такой страницы в devdeck нет',
    description:
      'Возможно, инструмент переехал, ссылка устарела или в адресе опечатка. Вернитесь в каталог и откройте доступную утилиту.',
    primaryAction: 'На главную',
    secondaryAction: 'К каталогу',
    fallbackTitle: 'Доступные инструменты',
  },

  categories: {
    count: 'Считать',
    clean: 'Чистить',
    format: 'Форматировать',
    encode: 'Кодировать',
    generate: 'Генерировать',
    test: 'Проверять',
    seo: 'SEO и соцсети',
  },

  tools: {
    textDiff: {
      title: 'Сравнить текст онлайн',
      shortDescription: 'Построчное сравнение двух текстов с подсветкой изменений.',
      longDescription:
        'Локальный text diff для кода, конфигов, логов и payload: строки и фрагменты сравниваются прямо в браузере.',
      seoTitle: 'Сравнить текст онлайн — text diff | devdeck.ru',
      seoDescription:
        'Сравните два текста онлайн с номерами строк и подсветкой добавлений и удалений. Игнорирование регистра и пробелов по краям строк, без отправки на сервер.',
      useCases: ['Код и конфиги', 'Логи', 'API payload', 'Черновики документации'],
      howTo: [
        'Вставьте исходный и изменённый текст в два поля.',
        'При необходимости включите игнорирование регистра или пробелов по краям строк.',
        'Нажмите «Сравнить» и изучите единый diff с номерами строк.',
        'Скопируйте читаемый unified diff или поменяйте тексты местами.',
      ],
      faq: [
        {
          question: 'Тексты отправляются на сервер?',
          answer: 'Нет. Сравнение полностью выполняется в браузере, содержимое полей не покидает устройство.',
        },
        {
          question: 'Какие пробелы можно игнорировать?',
          answer: 'Опция игнорирует только начальные и конечные пробелы каждой строки. Пробелы внутри строки остаются значимыми.',
        },
        {
          question: 'Есть ли ограничение размера?',
          answer: 'Да. Для стабильной работы принимается до 500 КБ и до 5 000 строк на каждую сторону.',
        },
      ],
    },
    jsonFormatter: {
      title: 'JSON formatter',
      shortDescription: 'Форматировать, минифицировать и проверить JSON.',
      longDescription: 'Читаемый JSON для API-ответов, логов и конфигов прямо в браузере.',
      seoTitle: 'JSON formatter онлайн — devdeck.ru',
      seoDescription: 'Форматируйте, минифицируйте и валидируйте JSON локально в браузере.',
      useCases: ['API responses', 'Логи', 'Конфиги', 'Минификация'],
      howTo: [
        'Вставьте JSON в редактор.',
        'Выберите «Форматировать», «Минифицировать» или «Проверить»: результат обновится после короткой паузы.',
        'Скопируйте результат обратно.',
      ],
      faq: [
        {
          question: 'Данные отправляются на сервер?',
          answer: 'Нет. JSON обрабатывается в браузере, данные не покидают устройство.',
        },
        {
          question: 'Большой JSON не повесит страницу?',
          answer: 'Обработка происходит синхронно. Если ваш JSON слишком большой, браузер может временно зависнуть. Для продакшн-нагрузок используйте специализированные инструменты.',
        },
      ],
    },
    jsonMinifier: {
      title: 'JSON minifier',
      shortDescription: 'Минифицировать JSON в одну компактную строку.',
      longDescription:
        'Сжатый JSON для payload, конфигов и передачи по сети с локальной проверкой синтаксиса.',
      seoTitle: 'JSON minifier онлайн — сжать JSON локально | devdeck.ru',
      seoDescription:
        'Минифицируйте JSON онлайн в браузере: уберите пробелы и переносы, проверьте синтаксис, скопируйте компактный результат. Бесплатно и без отправки на сервер.',
      useCases: ['API payload', 'Компактные конфиги', 'Webhook body', 'Передача по сети'],
      howTo: [
        'Вставьте JSON в редактор.',
        'Компактный результат обновится после короткой паузы и уберёт лишние пробелы и переносы.',
        'Проверьте parser error при некорректном JSON или скопируйте компактный результат.',
      ],
      faq: [
        {
          question: 'JSON отправляется на сервер?',
          answer:
            'Нет. Минификация выполняется через JSON.parse и JSON.stringify прямо в браузере.',
        },
        {
          question: 'Минификация меняет данные?',
          answer:
            'Нет. Инструмент удаляет только форматирование. Порядок ключей сохраняется таким, каким его возвращает стандартный JavaScript parser.',
        },
        {
          question: 'Чем отличается от JSON formatter?',
          answer:
            'JSON formatter делает документ читаемым с отступами, а JSON minifier создаёт компактный вариант для передачи, вставки в конфиги или payload.',
        },
      ],
    },
    yamlFormatter: {
      title: 'YAML formatter',
      shortDescription: 'Форматировать и валидировать YAML локально.',
      longDescription:
        'Читаемый YAML для конфигов, CI/CD, Kubernetes-манифестов и документации прямо в браузере.',
      seoTitle: 'YAML formatter онлайн — devdeck.ru',
      seoDescription:
        'Форматируйте и валидируйте YAML локально в браузере: понятные ошибки parser, copy и clear без отправки данных на сервер.',
      useCases: ['Конфиги', 'CI/CD', 'Kubernetes YAML', 'Документация'],
      howTo: [
        'Вставьте YAML в редактор.',
        'Нажмите «Форматировать», чтобы нормализовать отступы, или «Проверить», чтобы увидеть ошибки синтаксиса.',
        'Скопируйте результат или очистите поля.',
      ],
      faq: [
        {
          question: 'YAML отправляется на сервер?',
          answer:
            'Нет. Форматирование и валидация выполняются в браузере, данные не покидают устройство.',
        },
        {
          question: 'Показываются ли номера строк в ошибках?',
          answer:
            'Да. Если parser возвращает позицию, инструмент показывает строку и колонку рядом с сообщением об ошибке.',
        },
        {
          question: 'Поддерживаются ли несколько YAML-документов?',
          answer:
            'Да. YAML stream с разделителями --- разбирается локально и форматируется как несколько документов.',
        },
      ],
    },
    htmlFormatter: {
      title: 'HTML formatter',
      shortDescription: 'Форматировать и минифицировать HTML локально.',
      longDescription:
        'HTML formatter/minifier для разметки, email-шаблонов и фрагментов страниц: форматирование, минификация и понятные parser errors прямо в браузере.',
      seoTitle: 'HTML formatter онлайн — devdeck.ru',
      seoDescription:
        'Форматируйте и минифицируйте HTML локально в браузере: отступы, minify, copy, clear и понятные ошибки без отправки разметки на сервер.',
      useCases: ['HTML snippets', 'Email templates', 'Разметка страниц', 'Минификация'],
      howTo: [
        'Вставьте HTML в редактор.',
        'Нажмите «Форматировать» для читаемых отступов или «Минифицировать» для компактного вывода.',
        'Если parser не может разобрать разметку, исправьте ошибку по сообщению в результате.',
        'Скопируйте результат или очистите поля.',
      ],
      faq: [
        {
          question: 'HTML отправляется на сервер?',
          answer:
            'Нет. Форматирование и минификация выполняются в браузере, разметка не покидает устройство.',
        },
        {
          question: 'Что происходит с битой HTML-разметкой?',
          answer:
            'Инструмент пытается разобрать HTML локальным parser. Если синтаксис нельзя обработать, выводится понятная ошибка вместо некорректного результата.',
        },
        {
          question: 'Минификация меняет содержимое script или pre?',
          answer:
            'Нет. При минификации сохраняются блоки script, style, pre и textarea, чтобы не ломать значимые пробелы и код.',
        },
      ],
    },
    javascriptFormatter: {
      title: 'JavaScript formatter',
      shortDescription: 'Форматировать и минифицировать JavaScript локально.',
      longDescription:
        'JavaScript formatter/minifier для фрагментов кода, snippets и client-side bundle черновиков: Prettier formatting, Terser minify и понятные syntax errors без исполнения кода.',
      seoTitle: 'JavaScript formatter онлайн — devdeck.ru',
      seoDescription:
        'Форматируйте и минифицируйте JavaScript локально в браузере: Prettier, Terser, copy, clear и понятные ошибки синтаксиса без отправки кода на сервер.',
      useCases: ['JavaScript snippets', 'Code review', 'Bundle drafts', 'Минификация'],
      howTo: [
        'Вставьте JavaScript в редактор.',
        'Нажмите «Форматировать» для читаемых отступов или «Минифицировать» для компактного вывода.',
        'Если parser не может разобрать код, исправьте ошибку по сообщению в результате.',
        'Скопируйте результат или очистите поля.',
      ],
      faq: [
        {
          question: 'JavaScript отправляется на сервер?',
          answer:
            'Нет. Форматирование и минификация выполняются в браузере, исходный код не покидает устройство.',
        },
        {
          question: 'Инструмент исполняет вставленный код?',
          answer:
            'Нет. Код только разбирается parser и печатается обратно или минифицируется. eval, Function и запуск скриптов не используются.',
        },
        {
          question: 'Какие библиотеки используются?',
          answer:
            'Форматирование использует Prettier standalone с Babel/ESTree plugins, минификация — Terser. Обе библиотеки имеют permissive OSS-лицензии и загружаются только на странице инструмента.',
        },
      ],
    },
    cssFormatter: {
      title: 'CSS formatter',
      shortDescription: 'Форматировать и минифицировать CSS локально.',
      longDescription:
        'CSS formatter/minifier для stylesheet-фрагментов, component styles и theme tokens: Prettier formatting, minify, copy, clear и понятные syntax errors прямо в браузере.',
      seoTitle: 'CSS formatter онлайн — devdeck.ru',
      seoDescription:
        'Форматируйте и минифицируйте CSS локально в браузере: Prettier parser, minify, copy, clear и понятные ошибки синтаксиса без отправки стилей на сервер.',
      useCases: ['CSS snippets', 'Stylesheets', 'Theme tokens', 'Минификация'],
      howTo: [
        'Вставьте CSS в редактор.',
        'Нажмите «Форматировать» для читаемых отступов или «Минифицировать» для компактного вывода.',
        'Если parser не может разобрать стили, исправьте ошибку по сообщению в результате.',
        'Скопируйте результат или очистите поля.',
      ],
      faq: [
        {
          question: 'CSS отправляется на сервер?',
          answer:
            'Нет. Форматирование и минификация выполняются в браузере, stylesheet не покидает устройство.',
        },
        {
          question: 'Показываются ли ошибки синтаксиса?',
          answer:
            'Да. Инструмент использует CSS parser Prettier и показывает строку, колонку и сообщение ошибки, когда parser возвращает позицию.',
        },
        {
          question: 'Минификация меняет смысл CSS?',
          answer:
            'Минификация убирает комментарии и лишние пробелы после успешного parse. Перед продакшн-сборкой всё равно прогоняйте стили через свой pipeline, если он делает autoprefixing или advanced optimizations.',
        },
      ],
    },
    sqlFormatter: {
      title: 'SQL formatter',
      shortDescription: 'Форматировать SQL-запросы локально с выбором диалекта.',
      longDescription:
        'Локальный SQL formatter для SELECT, JOIN, CTE, INSERT и других запросов: читаемые отступы и ключевые слова в верхнем регистре, без отправки SQL на сервер.',
      seoTitle: 'SQL formatter онлайн — форматирование SQL-запросов | devdeck.ru',
      seoDescription:
        'SQL formatter онлайн: приведите запрос к читаемому виду с отступами и ключевыми словами в верхнем регистре. PostgreSQL, MySQL, SQLite и другие диалекты, локально в браузере.',
      useCases: ['SQL queries', 'JOIN и CTE', 'Миграции', 'Code review'],
      howTo: [
        'Вставьте SQL-запрос в редактор.',
        'Выберите dialect, если нужно слегка подстроить parser под PostgreSQL, MySQL, SQLite или другой синтаксис.',
        'Нажмите «Форматировать», чтобы получить читаемые отступы и uppercase keywords.',
        'Скопируйте результат или очистите поля.',
      ],
      faq: [
        {
          question: 'SQL отправляется на сервер?',
          answer:
            'Нет. Форматирование выполняется в браузере, исходный запрос и результат не отправляются на сервер.',
        },
        {
          question: 'Dialect selector проверяет корректность SQL для конкретной базы?',
          answer:
            'Нет. Dialect помогает formatter разобрать типичные синтаксические отличия, но не заменяет parser или semantic validation вашей СУБД.',
        },
        {
          question: 'Инструмент меняет смысл запроса?',
          answer:
            'Formatter меняет пробелы, переносы строк и регистр ключевых слов. Перед применением в продакшене всё равно проверяйте запрос в своей среде.',
        },
      ],
    },
    xmlFormatter: {
      title: 'XML formatter',
      shortDescription: 'Форматировать, минифицировать и валидировать XML локально.',
      longDescription:
        'XML formatter/validator для payload, SOAP, RSS, sitemap и конфигов: отступы, minify, copy, clear и parser errors прямо в браузере.',
      seoTitle: 'XML formatter онлайн — devdeck.ru',
      seoDescription:
        'Форматируйте, минифицируйте и валидируйте XML локально в браузере: отступы, minify, copy, clear и ошибки синтаксиса без отправки данных на сервер.',
      useCases: ['API payload', 'SOAP/XML ответы', 'RSS и sitemap', 'Конфиги'],
      howTo: [
        'Вставьте XML в редактор.',
        'Нажмите «Форматировать» для читаемых отступов, «Минифицировать» для компактной строки или «Проверить» для валидации.',
        'Если XML невалиден, исправьте ошибку parser. Номер строки и позиции показывается, когда браузер возвращает такую информацию.',
        'Скопируйте результат или очистите поля.',
      ],
      faq: [
        {
          question: 'XML отправляется на сервер?',
          answer:
            'Нет. Форматирование, минификация и валидация выполняются в браузере, XML не покидает устройство.',
        },
        {
          question: 'Показываются ли строка и колонка ошибки?',
          answer:
            'Да, когда XML parser браузера возвращает позицию. В остальных случаях показывается исходное сообщение parser.',
        },
        {
          question: 'Минификация меняет текст внутри тегов?',
          answer:
            'Минификация убирает пробелы между тегами, но не сжимает текстовые узлы внутри элементов.',
        },
      ],
    },
    csvToJson: {
      title: 'CSV в JSON',
      shortDescription: 'Конвертация CSV в JSON с автоопределением разделителя.',
      longDescription:
        'Локальный CSV to JSON converter для выгрузок, таблиц и тестовых данных: вставьте CSV или загрузите небольшой файл, выберите заголовки и получите JSON.',
      seoTitle: 'CSV в JSON онлайн — devdeck.ru',
      seoDescription:
        'Конвертируйте CSV в JSON локально в браузере: вставка текста, загрузка CSV-файла, автоопределение разделителя, режим заголовков, copy и download.',
      useCases: ['Экспорт таблиц', 'API payload', 'Тестовые данные', 'ETL черновики'],
      howTo: [
        'Вставьте CSV в редактор или загрузите небольшой .csv файл.',
        'Оставьте автоопределение разделителя или выберите запятую, точку с запятой, tab или pipe вручную.',
        'Включите режим строки заголовков, если первая строка содержит имена полей.',
        'Нажмите «Конвертировать» и скопируйте или скачайте JSON.',
      ],
      faq: [
        {
          question: 'CSV отправляется на сервер?',
          answer:
            'Нет. Конвертация выполняется в браузере, исходный CSV и результат не отправляются на сервер.',
        },
        {
          question: 'Какие разделители поддерживаются?',
          answer:
            'Поддерживаются запятая, точка с запятой, tab и pipe. Можно оставить автоопределение или выбрать разделитель вручную.',
        },
        {
          question: 'Поддерживаются ли значения в кавычках?',
          answer:
            'Да. Инструмент обрабатывает quoted fields, переносы строк CRLF и двойные кавычки внутри значения через "".',
        },
      ],
    },
    jsonToCsv: {
      title: 'JSON в CSV',
      shortDescription: 'Конвертация JSON массива или объекта в CSV с flatten nested полей.',
      longDescription:
        'Локальный JSON to CSV converter для API-ответов, экспортов и тестовых данных: вставьте JSON, получите CSV с заголовками и скачайте результат.',
      seoTitle: 'JSON в CSV онлайн — devdeck.ru',
      seoDescription:
        'Конвертируйте JSON в CSV локально в браузере: массивы и объекты, flatten вложенных полей, выбор разделителя, copy и download без отправки данных на сервер.',
      useCases: ['API responses', 'Экспорт в таблицу', 'Тестовые данные', 'ETL черновики'],
      howTo: [
        'Вставьте JSON объект или массив в редактор.',
        'Выберите разделитель CSV: запятая, точка с запятой, tab или pipe.',
        'Нажмите «Конвертировать». Вложенные поля будут раскрыты в колонки с dot/bracket путями.',
        'Скопируйте CSV или скачайте .csv файл.',
      ],
      faq: [
        {
          question: 'JSON отправляется на сервер?',
          answer:
            'Нет. Парсинг JSON, flatten полей и сборка CSV выполняются локально в браузере.',
        },
        {
          question: 'Что происходит с вложенными объектами и массивами?',
          answer:
            'Вложенные значения раскрываются в колонки: например profile.name или tags[0]. Пустые объекты и массивы сохраняются как {} и [].',
        },
        {
          question: 'Какая структура JSON поддерживается?',
          answer:
            'Поддерживается корневой объект или массив. Массив объектов превращается в несколько строк, одиночный объект — в одну строку. Корневые строки, числа и boolean отклоняются с понятной ошибкой.',
        },
      ],
    },
    base64: {
      title: 'Base64',
      shortDescription: 'Кодирование и декодирование строк в Base64, включая URL-safe и без =.',
      longDescription:
        'Локальное кодирование коротких текстовых фрагментов, токенов и тестовых payload в разных форматах Base64.',
      seoTitle: 'Base64 encode decode онлайн — devdeck.ru',
      seoDescription:
        'Кодируйте и декодируйте строки Base64, URL-safe Base64 и Base64 без padding локально в браузере.',
      useCases: ['Payload', 'Тестовые токены', 'URL-safe строки', 'Фрагменты конфигов'],
      howTo: [
        'Вставьте текст или Base64-строку в редактор.',
        'Выберите режим «Закодировать» или «Декодировать» и формат Base64: стандартный, без =, URL-safe или URL-safe без =.',
        'Нажмите «Закодировать» или «Декодировать».',
        'Скопируйте результат или поменяйте местами вход и выход через «Своп».',
      ],
      faq: [
        {
          question: 'Данные отправляются на сервер?',
          answer:
            'Нет. Весь процесс кодирования и декодирования происходит локально в браузере. Текст не покидает ваше устройство.',
        },
        {
          question: 'Поддерживается ли Base64 без знаков = в конце?',
          answer:
            'Да. Выберите формат «Без =» или «URL-safe без =». При декодировании инструмент добавит недостающий padding локально перед обработкой.',
        },
        {
          question: 'Почему декодирование выдаёт ошибку?',
          answer:
            'Base64 строка может содержать недопустимые символы или быть повреждена. Для стандартного формата используйте A-Z, a-z, 0-9, +, / и опциональные = в конце; для URL-safe — A-Z, a-z, 0-9, - и _.',
        },
        {
          question: 'Что такое Auto-режим?',
          answer:
            'Auto-режим анализирует введённый текст: если строка похожа на Base64, автоматически выбирается декодирование и подходящий формат; иначе — кодирование.',
        },
        {
          question: 'Кодирование с русским текстом работает?',
          answer:
            'Да. Текст предварительно преобразуется в UTF-8, после чего кодируется в Base64. Все языки и символы Unicode поддерживаются.',
        },
      ],
    },
    htmlEntities: {
      title: 'HTML entities',
      shortDescription: 'Экранирование и декодирование HTML entities, named и numeric.',
      longDescription:
        'Локальный HTML entities encoder/decoder для markup, шаблонов, CMS-полей и тестовых HTML-фрагментов. Кодируйте опасные символы или декодируйте named и numeric entities прямо в браузере.',
      seoTitle: 'HTML entities encode decode онлайн — devdeck.ru',
      seoDescription:
        'Кодируйте и декодируйте HTML entities локально в браузере: &amp;, &lt;, &quot;, numeric entities, copy и swap без отправки данных на сервер.',
      useCases: ['HTML templates', 'CMS snippets', 'XML/markup', 'Escaping'],
      howTo: [
        'Вставьте текст или строку с HTML entities в редактор.',
        'Выберите «Закодировать», чтобы экранировать HTML-символы, или «Декодировать», чтобы вернуть обычный текст.',
        'При необходимости включите кодирование non-ASCII символов в numeric entities.',
        'Скопируйте результат или поменяйте вход и выход местами.',
      ],
      faq: [
        {
          question: 'Текст отправляется на сервер?',
          answer:
            'Нет. Кодирование и декодирование HTML entities выполняется локально в браузере.',
        },
        {
          question: 'Какие entities поддерживаются при декодировании?',
          answer:
            'Декодирование использует HTML-парсер браузера, поэтому поддерживает named entities вроде `&amp;` и `&copy;`, decimal numeric entities вроде `&#169;` и hexadecimal numeric entities вроде `&#xA9;` там, где их поддерживает текущий браузер.',
        },
        {
          question: 'Кодирование превращает весь Unicode в entities?',
          answer:
            'По умолчанию кодируются символы, опасные для HTML: &, <, >, кавычки, апостроф и backtick. Для кириллицы, emoji и других non-ASCII символов можно включить numeric encoding отдельной опцией.',
        },
      ],
    },
    urlCodec: {
      title: 'URL encode/decode',
      shortDescription: 'Кодировать query params и декодировать URL-фрагменты.',
      longDescription:
        'Быстрая работа с URL, query string и percent-encoding без сетевых запросов.',
      seoTitle: 'URL encode decode онлайн — devdeck.ru',
      seoDescription:
        'Кодируйте и декодируйте URL, query params и percent-encoded строки локально в браузере. Бесплатно, без регистрации и отправки данных на сервер.',
      useCases: ['Query params', 'Redirect URL', 'Webhook payload', 'UTM и callback URL'],
      howTo: [
        'Выберите режим «Закодировать» или «Декодировать».',
        'Выберите область: whole URL, component или query.',
        'Вставьте строку и нажмите кнопку обработки.',
        'Скопируйте результат или поменяйте вход и выход местами.',
      ],
      faq: [
        {
          question: 'URL отправляется на сервер?',
          answer:
            'Нет. Кодирование и декодирование выполняются встроенными browser API прямо на устройстве.',
        },
        {
          question: 'Чем whole URL отличается от component?',
          answer:
            'Whole URL сохраняет символы-разделители вроде : / ? & = и кодирует только небезопасные части. Component кодирует строку целиком, поэтому подходит для значения query-параметра.',
        },
        {
          question: 'Почему декодирование может показать ошибку?',
          answer:
            'Percent-encoding должен содержать пары вида %2F. Если во входе есть одиночный % или битая UTF-8 последовательность, браузер не может безопасно декодировать строку.',
        },
      ],
    },
    utmGenerator: {
      title: 'Генератор UTM-меток',
      shortDescription: 'Собрать ссылку с UTM-метками и сохранить query-параметры.',
      longDescription:
        'Локальный конструктор UTM-ссылок для кампаний: заменяет существующие UTM-метки, сохраняет остальные параметры и hash.',
      seoTitle: 'UTM generator онлайн — генератор UTM-меток | devdeck.ru',
      seoDescription:
        'UTM generator: создайте ссылку с utm_source, utm_medium и utm_campaign онлайн. Существующие query и hash сохраняются, данные обрабатываются локально в браузере.',
      useCases: ['Email-рассылки', 'Рекламные кампании', 'Баннеры', 'Ссылки в публикациях'],
      howTo: [
        'Вставьте полный адрес страницы с http:// или https://.',
        'Заполните обязательные source, medium и campaign.',
        'При необходимости добавьте term и content.',
        'Соберите ссылку, проверьте её и скопируйте результат.',
      ],
      faq: [
        {
          question: 'Ссылка и UTM-метки отправляются на сервер?',
          answer:
            'Нет. URL собирается встроенным API браузера, а значения полей не отправляются на сервер и не попадают в аналитику.',
        },
        {
          question: 'Что произойдёт с параметрами и якорем исходной ссылки?',
          answer:
            'Обычные query-параметры и hash сохранятся. Существующие lowercase UTM-параметры будут удалены и заменены новыми значениями.',
        },
        {
          question: 'Какие поля обязательны?',
          answer:
            'Обязательны utm_source, utm_medium и utm_campaign. utm_term и utm_content добавляются только когда они заполнены.',
        },
      ],
    },
    uuidGenerator: {
      title: 'UUID generator',
      shortDescription: 'Генерация UUID v1, v4, v6 и v7 — один или несколько, с настройками.',
      longDescription: 'Генератор UUID v1, v4, v6 и v7 для идентификаторов, тестовых данных и API-запросов. Работает локально в браузере на crypto.getRandomValues.',
      seoTitle: 'UUID generator онлайн — devdeck.ru',
      seoDescription: 'Генерируйте UUID v1, v4, v6 и v7 локально в браузере: несколько UUID, uppercase/lowercase, с дефисами и без.',
      useCases: ['ID для БД', 'Тестовые данные', 'API-запросы', 'Идентификаторы'],
      howTo: [
        'Выберите версию UUID: v4, v7, v1 или v6.',
        'Укажите количество UUID (от 1 до 1000).',
        'Выберите регистр: abc (нижний) или ABC (верхний).',
        'Выберите формат дефисов: с дефисами или без.',
        'Нажмите «Сгенерировать» и скопируйте результат.',
      ],
      faq: [
        {
          question: 'UUID генерируются локально?',
          answer: 'Да. Все UUID создаются прямо в вашем браузере с использованием криптостойкого генератора случайных чисел (crypto.getRandomValues). Данные не отправляются на сервер.',
        },
        {
          question: 'Можно ли сгенерировать много UUID сразу?',
          answer: 'Да. Вы можете сгенерировать до 1000 UUID за один раз. Для больших объёмов используйте специализированные инструменты.',
        },
        {
          question: 'Чем UUID v4 отличается от других версий?',
          answer: 'UUID v4 основан на случайных числах и подходит для большинства сценариев. UUID v7 и v6 сортируются по времени создания, поэтому удобны для индексов и логов. UUID v1 тоже основан на времени, но в этом генераторе использует случайный node id, а не MAC-адрес.',
        },
        {
          question: 'Зачем убирать дефисы?',
          answer: 'Некоторые системы (например, базы данных, filename) не поддерживают дефисы в идентификаторах. Без дефисов UUID короче и проще для копирования в определённых контекстах.',
        },
      ],
    },
    regexTester: {
      title: 'Regex tester',
      shortDescription: 'Проверка регулярных выражений, флагов, совпадений и групп.',
      longDescription: 'Локальный тестер регулярных выражений для разработчиков: введите pattern, flags и тестовый текст, подсветите совпадения и проверьте группы без отправки данных на сервер.',
      seoTitle: 'Regex tester онлайн — devdeck.ru',
      seoDescription: 'Проверяйте регулярные выражения онлайн: pattern, flags, подсветка совпадений, группы и ошибки regex. Работает локально в браузере.',
      useCases: ['Regex для кода', 'Парсинг логов', 'Группы захвата', 'Валидация pattern'],
      howTo: [
        'Введите регулярное выражение без внешних слэшей.',
        'Укажите флаги JavaScript RegExp, например g, i, m или u.',
        'Вставьте тестовый текст и нажмите «Проверить».',
        'Посмотрите подсветку совпадений и список групп.',
      ],
      faq: [
        {
          question: 'Pattern и тестовый текст отправляются на сервер?',
          answer: 'Нет. Проверка выполняется через JavaScript RegExp прямо в браузере. Данные не отправляются и не сохраняются на сервере.',
        },
        {
          question: 'Какие флаги поддерживаются?',
          answer: 'Поддерживаются флаги, которые понимает текущий браузер: например g, i, m, s, u, v и d. Некорректные или повторяющиеся флаги покажут ошибку.',
        },
        {
          question: 'Почему совпадений максимум 500?',
          answer: 'Лимит защищает страницу от слишком тяжёлых выражений и огромного количества совпадений. Первые 500 совпадений всё равно показываются.',
        },
      ],
    },
    jwtDecoder: {
      title: 'JWT decoder',
      shortDescription: 'Посмотреть header и payload JWT без отправки токена на сервер.',
      longDescription:
        'Локальная инспекция JSON-содержимого JWT для отладки авторизации. Подпись токена не проверяется.',
      seoTitle: 'JWT decoder онлайн — расшифровать токен локально | devdeck.ru',
      seoDescription:
        'Декодируйте header и payload JWT локально в браузере. Токен не отправляется на сервер, подпись не проверяется.',
      useCases: ['Отладка авторизации', 'Просмотр claims', 'Проверка срока действия', 'Инспекция header'],
      howTo: [
        'Вставьте JWT из трёх разделённых точками сегментов.',
        'Нажмите «Декодировать JWT».',
        'Изучите отформатированные JSON header и payload.',
        'Не считайте результат проверкой подлинности: подпись этим инструментом не проверяется.',
      ],
      faq: [
        {
          question: 'JWT отправляется на сервер?',
          answer: 'Нет. Токен декодируется только в вашем браузере и не попадает в аналитику.',
        },
        {
          question: 'Инструмент проверяет подпись JWT?',
          answer: 'Нет. Он только декодирует header и payload. Доверять claims можно лишь после отдельной проверки подписи.',
        },
        {
          question: 'Почему токен не декодируется?',
          answer: 'JWT должен состоять из трёх сегментов. Header и payload должны содержать Base64URL-кодированные JSON-объекты, а подписанный JWT — непустую Base64URL-подпись. Для alg «none» подпись должна быть пустой.',
        },
      ],
    },
    cronGenerator: {
      title: 'Cron generator',
      shortDescription: 'Парсер cron-выражений, простая сборка расписаний и ближайшие запуски.',
      longDescription: 'Локальный помощник для cron: проверьте 5-польное выражение, соберите расписание по минутам, часам, дням, месяцам и дням недели, посмотрите ближайшие запуски в своём часовом поясе.',
      seoTitle: 'Cron выражение онлайн — генератор и проверка | devdeck.ru',
      seoDescription: 'Составьте и проверьте cron выражение онлайн: расписание понятным языком, конструктор минут, часов, дней и месяцев, ближайшие запуски. Локально в браузере.',
      useCases: ['CI расписания', 'Kubernetes CronJob', 'Бэкапы', 'Периодические задачи'],
      howTo: [
        'Вставьте cron-выражение из 5 полей: minute hour day month weekday.',
        'Нажмите «Разобрать», чтобы увидеть описание и ближайшие запуски.',
        'Используйте builder, если нужно быстро собрать простое расписание.',
        'Проверьте timezone caveat перед переносом выражения в серверную среду.',
      ],
      faq: [
        {
          question: 'Cron-выражение отправляется на сервер?',
          answer: 'Нет. Парсинг, генерация и расчёт ближайших запусков выполняются локально в браузере.',
        },
        {
          question: 'Какой формат cron поддерживается?',
          answer: 'Поддерживается стандартный 5-польный формат: minute hour day month weekday. Секунды и год не используются.',
        },
        {
          question: 'Поддерживаются ли MON или JAN?',
          answer: 'Да. Для месяца и дня недели можно использовать числовые значения или короткие английские алиасы вроде JAN, MON, FRI.',
        },
      ],
    },
    markdownEditor: {
      title: 'Markdown редактор онлайн',
      shortDescription: 'Редактируйте Markdown и сразу смотрите безопасный HTML.',
      longDescription:
        'Локальный Markdown-редактор с предпросмотром на лету, GFM-таблицами, task lists, статистикой и экспортом в Markdown или HTML.',
      seoTitle: 'Markdown онлайн — редактор с предпросмотром | devdeck.ru',
      seoDescription:
        'Редактируйте Markdown онлайн: безопасный предпросмотр на лету, копирование HTML, скачивание .md и .html. CommonMark и GFM, локально в браузере.',
      useCases: ['README и документация', 'Предпросмотр Markdown', 'Markdown в HTML', 'GFM-таблицы'],
      howTo: [
        'Введите или вставьте Markdown в левую панель.',
        'Проверьте live preview и статистику заголовков, ссылок, таблиц и слов.',
        'Скопируйте исходный Markdown или безопасный HTML fragment либо скачайте .md/.html.',
      ],
      faq: [
        {
          question: 'Какой вариант Markdown поддерживается?',
          answer: 'Редактор следует CommonMark и GFM-подобным расширениям: таблицы, task lists, зачёркивание и autolinks. Полное совпадение с конкретными платформами не гарантируется.',
        },
        {
          question: 'Можно ли вставлять raw HTML?',
          answer: 'Raw HTML распознаётся, но не интерпретируется и не попадает в preview или export. Результат дополнительно проходит sanitizer, который удаляет опасные элементы, атрибуты и URL-схемы.',
        },
        {
          question: 'Markdown отправляется на сервер?',
          answer: 'Нет. Парсинг, preview, статистика и экспорт выполняются локально в браузере. Изображения намеренно не загружаются и не включаются в HTML preview/export.',
        },
        {
          question: 'Какой максимальный размер документа?',
          answer: 'Редактор принимает до 256 КиБ Markdown в UTF-8 для копирования и экспорта. Live preview обрабатывает в отдельном Web Worker документы до 64 КиБ, чтобы ограничить память и время фонового parse/render.',
        },
      ],
    },
    textHashGenerator: {
      title: 'Генератор хэшей текста',
      shortDescription: 'SHA-256, SHA-1 и MD5 для UTF-8 текста прямо в браузере.',
      longDescription:
        'Локальный генератор хэшей для строк, тестовых payload и проверки совместимости. Исходный текст не покидает браузер.',
      seoTitle: 'MD5 и SHA генератор хэшей текста онлайн | devdeck.ru',
      seoDescription:
        'Получите SHA-256, SHA-1 и MD5 для UTF-8 текста локально в браузере. Копирование результата, без загрузки файлов и отправки текста на сервер.',
      useCases: ['SHA-256 текста', 'Проверка интеграций', 'Тестовые payload', 'Legacy MD5 и SHA-1'],
      howTo: [
        'Введите или вставьте текст в левое поле.',
        'Нажмите «Рассчитать хэши». Пустая строка тоже имеет корректные хэши.',
        'Скопируйте нужный SHA-256, SHA-1 или MD5 отдельной кнопкой.',
        'Для паролей, подписей и других security-sensitive задач не используйте MD5 и SHA-1.',
      ],
      faq: [
        {
          question: 'Текст отправляется на сервер или в аналитику?',
          answer: 'Нет. UTF-8 байты и хэши вычисляются локально в браузере. Аналитика получает только служебные метаданные: действие, число алгоритмов, длину текста при запуске и успешном результате, длительность успешного расчёта либо код ошибки — без текста и digest.',
        },
        {
          question: 'Какая кодировка используется?',
          answer: 'Текст преобразуется в UTF-8 через стандартный TextEncoder. Поэтому результат совпадает с CLI-инструментами, если они получают те же UTF-8 байты.',
        },
        {
          question: 'Можно ли использовать MD5 или SHA-1 для паролей и подписей?',
          answer: 'Нет. MD5 и SHA-1 считаются криптографически устаревшими и показаны только для совместимости. Для хранения паролей нужны специальные password-hashing алгоритмы с солью.',
        },
      ],
    },
  },

  base64: {
    sourceText: 'Исходный текст',
    base64String: 'Base64 строка',
    decodedText: 'Декодированный текст',
    resultTitle: 'Base64 результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    swap: 'Своп',
    inputEncodePlaceholder: 'Введите текст для кодирования в Base64...',
    inputDecodePlaceholder: 'Введите Base64 строку для декодирования...',
    outputPlaceholder: 'Результат появится здесь...',
    encodeLabel: 'Текст для кодирования',
    decodeLabel: 'Base64 строка для декодирования',
    resultLabel: 'Результат',
    mode: 'Режим:',
    format: 'Формат:',
    variants: {
      standard: 'Стандарт',
      'standard-no-padding': 'Без =',
      'url-safe': 'URL-safe',
      'url-safe-no-padding': 'URL-safe без =',
    },
    encode: 'Закодировать',
    decode: 'Декодировать',
    auto: 'Auto',
    autoHint: 'Похоже на Base64 — попробуйте «Декодировать»',
    inputLength: 'Длина входа',
    resultLength: 'Длина результата',
    sourceSize: 'Исходный размер',
    characters: 'символов',
    lines: 'строк',
    base64Chars: 'знаков Base64',
    howTitle: 'Как это работает',
    how:
      'Base64 кодирует бинарные данные в текстовый формат. Стандартный алфавит использует A-Z, a-z, 0-9, + и /, а URL-safe вариант заменяет + и / на - и _. Padding в конце можно оставить или убрать. Все вычисления выполняются локально в вашем браузере — текст не отправляется на сервер.',
    whenTitle: 'Когда использовать',
    when:
      'Кодирование: подготовка текстовых payload для API, передача бинарных данных через JSON, создание Data URL, хранение маленьких файлов в текстовом виде. Декодирование: просмотр содержимого Base64-токенов, отладка API-ответов, расшифровка JWT-сегментов.',
    errors: {
      encode: 'Ошибка кодирования: текст содержит неподдерживаемые символы',
      emptyDecode: 'Нет данных для декодирования',
      invalid:
        'Некорректная Base64 строка для выбранного формата. Проверьте алфавит, длину строки и знак = в конце.',
      invalidUtf8:
        'Результат декодирования не является валидным UTF-8. Возможно, это бинарные данные, а не текст.',
      unknown: 'Неизвестная ошибка',
    },
  },

  htmlEntities: {
    sourceText: 'Исходный текст',
    entitiesText: 'HTML entities',
    resultTitle: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    swap: 'Своп',
    inputEncodePlaceholder: '<button title="Save & close">Сохранить</button>',
    inputDecodePlaceholder: '&lt;button title=&quot;Save &amp; close&quot;&gt;Сохранить&lt;/button&gt;',
    outputPlaceholder: 'Результат появится здесь...',
    encodeLabel: 'Текст для кодирования в HTML entities',
    decodeLabel: 'HTML entities для декодирования',
    resultLabel: 'Результат обработки HTML entities',
    mode: 'Режим:',
    encode: 'Закодировать',
    decode: 'Декодировать',
    encodeAction: 'Закодировать',
    decodeAction: 'Декодировать',
    encodeNonAscii: 'Кодировать non-ASCII как numeric entities',
    characters: 'Символов',
    lines: 'Строк',
    entities: 'Entities',
    inputEntities: 'Entities во входе',
    resultEntities: 'Entities в результате',
    detectedEntities: 'найдено по шаблону &...;',
    processing: 'Обработка',
    localOnly: 'Локально в браузере',
    howTitle: 'Как это работает',
    how:
      'Кодирование заменяет HTML-значимые символы &, <, >, кавычки, апостроф и backtick на entities, чтобы текст можно было безопасно вставить в markup. Декодирование использует HTML-парсер браузера через textarea, поэтому понимает named entities вроде `&amp;`, decimal numeric вроде `&#169;` и hexadecimal numeric вроде `&#xA9;`.',
    whenTitle: 'Когда использовать',
    when:
      'Инструмент полезен при подготовке HTML-шаблонов, CMS-snippets, XML/markup-фрагментов, email-разметки и тестовых payload, где нужно быстро увидеть escaped или decoded вариант строки.',
    errors: {
      unknown: 'Не удалось обработать HTML entities.',
    },
  },

  urlCodec: {
    sourceText: 'Исходная строка',
    encodedText: 'Закодированная URL-строка',
    resultTitle: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    swap: 'Своп',
    inputEncodePlaceholder: 'https://example.dev/search?q=hello world&redirect=/docs',
    inputDecodePlaceholder: 'hello%20world%2Fdocs%3Ftab%3Dapi',
    outputPlaceholder: 'Результат появится здесь...',
    encodeLabel: 'Строка для URL encoding',
    decodeLabel: 'Percent-encoded строка для декодирования',
    resultLabel: 'Результат URL encode/decode',
    mode: 'Режим:',
    target: 'Область:',
    targets: {
      url: 'Whole URL',
      component: 'Component',
      query: 'Query',
    },
    encode: 'Закодировать',
    decode: 'Декодировать',
    encodeAction: 'Закодировать',
    decodeAction: 'Декодировать',
    characters: 'Символов',
    lines: 'Строк',
    percentSequences: '% sequences',
    queryParts: 'Query parts',
    inResult: 'в результате',
    simpleQueryHint: 'простая оценка по &',
    processing: 'Обработка',
    localOnly: 'Локально в браузере',
    howTitle: 'Как это работает',
    how:
      'Whole URL использует encodeURI/decodeURI и сохраняет URL-разделители. Component использует encodeURIComponent/decodeURIComponent и кодирует строку целиком. Query работает как component, но при encode заменяет пробелы на +, а при decode воспринимает + как пробел.',
    whenTitle: 'Когда использовать',
    when:
      'Инструмент удобен для query params, callback URL, redirect_uri, webhook payload, UTM-строк и отладки percent-encoded значений в логах или API-запросах.',
    errors: {
      invalidPercent:
        'Некорректный percent-encoding. Проверьте одиночные %, пары вида %2F и UTF-8 последовательности.',
      invalidEncoding:
        'Не удалось закодировать строку. Проверьте, нет ли во входе некорректных Unicode surrogate-символов.',
      unknown: 'Не удалось обработать URL строку.',
    },
  },

  utmGenerator: {
    formTitle: 'Параметры кампании',
    baseUrl: 'Исходный URL',
    source: 'utm_source',
    medium: 'utm_medium',
    campaign: 'utm_campaign',
    term: 'utm_term (необязательно)',
    content: 'utm_content (необязательно)',
    optionalPlaceholder: 'Оставьте пустым, если не нужно',
    build: 'Собрать ссылку',
    reset: 'Сбросить',
    previewTitle: 'Итоговая ссылка',
    previewLabel: 'Ссылка с UTM-метками',
    previewPlaceholder: 'Заполните поля и соберите ссылку.',
    copy: 'Копировать',
    copied: 'Скопировано',
    localOnly:
      'Ссылка собирается локально. Инструмент не открывает её и не отправляет значения полей на сервер.',
    errors: {
      'empty-url': 'Введите исходный URL.',
      'invalid-url': 'Введите полный корректный URL, например https://example.ru/page.',
      'unsupported-protocol': 'Поддерживаются только безопасные протоколы HTTP и HTTPS.',
      'missing-required-fields': 'Заполните utm_source, utm_medium и utm_campaign.',
    },
  },

  jsonFormatter: {
    input: 'Входной JSON',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    minify: 'Минифицировать',
    validate: 'Проверить',
    inputPlaceholder: 'Вставьте JSON для форматирования...',
    outputPlaceholder: 'Форматированный JSON появится здесь...',
    valid: 'JSON валиден ✓',
    characters: 'символов',
    lines: 'строк',
    errors: {
      invalidJson: 'Некорректный JSON: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'JSON formatter парсит ваш JSON через стандартный JSON.parse браузера, проверяет синтаксис и форматирует вывод с отступами. Минификация удаляет лишние пробелы, сохраняя структуру. Все вычисления выполняются локально в браузере — данные не отправляются на сервер.',
    whenTitle: 'Когда использовать',
    when:
      'Форматирование: подготовка API-ответов для чтения, отладка логов, просмотр конфигов. Минификация: уменьшение размера JSON для передачи по сети, подготовка payload для запросов. Валидация: быстрая проверка JSON перед использованием в коде или конфигурации.',
  },

  jsonMinifier: {
    input: 'Входной JSON',
    output: 'Минифицированный JSON',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    minify: 'Минифицировать',
    inputPlaceholder:
      '{\n  "service": "api",\n  "enabled": true,\n  "limits": { "retries": 3 }\n}',
    outputPlaceholder: 'Компактный JSON появится здесь...',
    minified: 'JSON минифицирован',
    characters: 'символов',
    lines: 'строк',
    saved: 'сэкономлено',
    errors: {
      invalidJson: 'Некорректный JSON: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'JSON minifier использует тот же локальный JSON.parse parser, что и JSON formatter. После успешной проверки он сериализует значение через JSON.stringify без отступов, поэтому пробелы и переносы исчезают, а структура данных сохраняется.',
    whenTitle: 'Когда использовать',
    when:
      'Минификация полезна для компактных API payload, webhook body, JSON в переменных окружения, тестовых фикстур и конфигов, где важен размер или вставка в одну строку. Для чтения и ревью используйте JSON formatter.',
  },

  yamlFormatter: {
    input: 'Входной YAML',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    validate: 'Проверить',
    inputPlaceholder: 'Вставьте YAML для форматирования...',
    outputPlaceholder: 'Форматированный YAML появится здесь...',
    valid: 'YAML валиден',
    characters: 'символов',
    lines: 'строк',
    errors: {
      invalidYaml: 'Некорректный YAML: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'YAML formatter разбирает документ в браузере, проверяет parser errors и выводит YAML с едиными отступами. Для YAML stream несколько документов форматируются по очереди. Все вычисления локальные — данные не отправляются на сервер.',
    whenTitle: 'Когда использовать',
    when:
      'Форматирование полезно для конфигов, CI/CD pipeline, Kubernetes-манифестов, docker compose фрагментов и документации. Валидация помогает быстро найти синтаксическую ошибку перед коммитом или вставкой YAML в другой инструмент.',
  },

  htmlFormatter: {
    input: 'Входной HTML',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    minify: 'Минифицировать',
    inputPlaceholder: '<main>\n  <h1>Заголовок</h1>\n  <p>HTML фрагмент...</p>\n</main>',
    outputPlaceholder: 'Форматированный или минифицированный HTML появится здесь...',
    formatted: 'HTML отформатирован',
    minified: 'HTML минифицирован',
    characters: 'символов',
    lines: 'строк',
    errors: {
      invalidHtml: 'HTML не удалось обработать: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'HTML formatter использует браузерную сборку Prettier parser для HTML. Форматирование нормализует отступы и переносы, а минификация сначала проверяет разметку parser, затем сжимает пробелы между тегами. Всё выполняется локально — HTML не отправляется на сервер.',
    whenTitle: 'Когда использовать',
    when:
      'Форматирование помогает читать фрагменты шаблонов, email-разметку, скопированный HTML и компоненты перед ревью. Минификация полезна для компактной вставки небольших HTML-фрагментов в конфиги, тесты или CMS-поля.',
  },

  javascriptFormatter: {
    input: 'Входной JavaScript',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    minify: 'Минифицировать',
    inputPlaceholder: 'function greet(name){ console.log(`Hello, ${name}`) }',
    outputPlaceholder: 'Форматированный или минифицированный JavaScript появится здесь...',
    formatted: 'JavaScript отформатирован',
    minified: 'JavaScript минифицирован',
    characters: 'символов',
    lines: 'строк',
    errors: {
      invalidJavaScript: 'JavaScript не удалось обработать: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'JavaScript formatter lazy-load использует Prettier standalone с Babel/ESTree parser plugins для форматирования и Terser для минификации. Оба шага работают с AST локально в браузере и не исполняют пользовательский код.',
    whenTitle: 'Когда использовать',
    when:
      'Форматирование полезно для чтения snippets, отладки скопированного кода и подготовки фрагментов к ревью. Минификация помогает быстро получить компактный вариант небольшого browser-side скрипта или тестового payload.',
  },

  cssFormatter: {
    input: 'Входной CSS',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    minify: 'Минифицировать',
    inputPlaceholder: '.card { display: grid; gap: 16px; color: #1f2937; }',
    outputPlaceholder: 'Форматированный или минифицированный CSS появится здесь...',
    formatted: 'CSS отформатирован',
    minified: 'CSS минифицирован',
    characters: 'символов',
    lines: 'строк',
    errors: {
      invalidCss: 'CSS не удалось обработать: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'CSS formatter lazy-load использует Prettier standalone с PostCSS parser plugin для разбора и форматирования stylesheet. Минификация сначала валидирует CSS тем же parser, затем удаляет комментарии и лишние пробелы. Всё выполняется локально — CSS не отправляется на сервер.',
    whenTitle: 'Когда использовать',
    when:
      'Форматирование помогает читать скопированные stylesheet-фрагменты, component styles, theme tokens и CSS из DevTools перед ревью. Минификация полезна для компактной вставки небольших стилей в тесты, embeds или черновики конфигов.',
  },

  sqlFormatter: {
    input: 'Входной SQL',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    formatting: 'Форматируется...',
    dialect: 'Dialect',
    inputPlaceholder: 'select u.id, u.email, count(o.id) as orders from users u left join orders o on o.user_id = u.id where u.active = true group by u.id, u.email order by orders desc;',
    outputPlaceholder: 'Форматированный SQL появится здесь...',
    formatted: 'SQL отформатирован',
    characters: 'символов',
    lines: 'строк',
    dialects: {
      sql: 'Generic SQL',
      postgresql: 'PostgreSQL',
      mysql: 'MySQL',
      sqlite: 'SQLite',
      mariadb: 'MariaDB',
      transactsql: 'Transact-SQL',
      bigquery: 'BigQuery',
      snowflake: 'Snowflake',
    },
    errors: {
      invalidSql: 'SQL не удалось обработать: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'SQL formatter загружает локальную browser-сборку formatter-библиотеки и перестраивает запрос с едиными отступами, переносами строк и uppercase keywords. Выбранный dialect помогает parser с распространёнными отличиями синтаксиса, но не выполняет semantic validation и не подключается к базе данных.',
    whenTitle: 'Когда использовать',
    when:
      'Форматирование полезно перед code review, разбором длинных SELECT с JOIN/CTE, подготовкой миграций и чтением SQL из логов. Для проверки плана выполнения, типов колонок и существования таблиц используйте свою СУБД или CI.',
  },

  xmlFormatter: {
    input: 'Входной XML',
    output: 'Результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    format: 'Форматировать',
    minify: 'Минифицировать',
    validate: 'Проверить',
    inputPlaceholder: '<root>\n  <item id="1">value</item>\n</root>',
    outputPlaceholder: 'Форматированный или минифицированный XML появится здесь...',
    formatted: 'XML отформатирован',
    minified: 'XML минифицирован',
    valid: 'XML валиден',
    characters: 'символов',
    lines: 'строк',
    errors: {
      invalidXml: 'Некорректный XML: {error}',
    },
    howTitle: 'Как это работает',
    how:
      'XML formatter сначала валидирует документ через DOMParser браузера, затем форматирует структуру с отступом в два пробела или убирает whitespace между тегами для минификации. Всё выполняется локально — XML не отправляется на сервер.',
    whenTitle: 'Когда использовать',
    when:
      'Инструмент полезен для SOAP/XML ответов, RSS, sitemap.xml, Android/vector XML, конфигов и тестовых payload, где нужно быстро проверить well-formed XML перед вставкой в код или отправкой запроса.',
  },

  csvToJson: {
    input: 'Входной CSV',
    output: 'JSON результат',
    upload: 'Загрузить CSV',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    download: 'Скачать .json',
    convert: 'Конвертировать',
    convertLarge: 'Конвертировать большой ввод',
    autoPreviewLimit:
      'Автопредпросмотр работает до 128 КиБ. Для большего ввода запустите конвертацию явно.',
    inputPlaceholder: 'name,email\nAda,ada@example.com\nLinus,linus@example.com',
    outputPlaceholder: 'JSON появится здесь после конвертации...',
    delimiter: 'Разделитель',
    headerRow: 'Первая строка — заголовки',
    detected: 'Обнаружено',
    delimiterUsed: 'Разделитель',
    rows: 'Строк данных',
    columns: 'Колонок',
    characters: 'символов',
    lines: 'строк',
    delimiters: {
      auto: 'Авто',
      comma: 'Запятая (,)',
      semicolon: 'Точка с запятой (;)',
      tab: 'Tab',
      pipe: 'Pipe (|)',
    },
    delimiterSymbols: {
      ',': ',',
      ';': ';',
      '\t': 'Tab',
      '|': '|',
    },
    errors: {
      empty: 'Добавьте CSV для конвертации.',
      unclosedQuote: 'Некорректный CSV: не закрыта кавычка в значении.',
      fileTooLarge: 'Файл слишком большой. Загрузите CSV до 1 МБ.',
      fileRead: 'Не удалось прочитать файл.',
    },
    howTitle: 'Как это работает',
    how:
      'Инструмент разбирает CSV локально в браузере: определяет разделитель, учитывает кавычки и превращает строки в массив объектов при включённой строке заголовков. Если заголовки выключены, результатом будет массив массивов.',
    whenTitle: 'Когда использовать',
    when:
      'CSV в JSON полезен для быстрых API payload, проверки табличных экспортов, подготовки тестовых данных, прототипирования ETL и ручной нормализации небольших выгрузок.',
  },

  jsonToCsv: {
    input: 'Входной JSON',
    output: 'CSV результат',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    download: 'Скачать .csv',
    convert: 'Конвертировать',
    convertLarge: 'Конвертировать большой ввод',
    autoPreviewLimit:
      'Автопредпросмотр работает до 128 КиБ. Для большего ввода запустите конвертацию явно.',
    inputPlaceholder:
      '[\n  { "name": "Ada", "email": "ada@example.com", "profile": { "role": "admin" } },\n  { "name": "Linus", "email": "linus@example.com", "profile": { "role": "dev" } }\n]',
    outputPlaceholder: 'CSV появится здесь после конвертации...',
    delimiter: 'Разделитель',
    rows: 'Строк данных',
    columns: 'Колонок',
    flattened: 'Flatten полей',
    characters: 'символов',
    lines: 'строк',
    delimiters: {
      comma: 'Запятая (,)',
      semicolon: 'Точка с запятой (;)',
      tab: 'Tab',
      pipe: 'Pipe (|)',
    },
    errors: {
      empty: 'Добавьте JSON для конвертации.',
      invalidJson: 'Некорректный JSON: {error}',
      unsupportedRoot:
        'Корневое значение должно быть объектом или массивом. Строки, числа и boolean нельзя превратить в таблицу без колонок.',
      complexityLimit:
        'JSON слишком глубокий или содержит слишком много строк, колонок либо значений для безопасного локального предпросмотра.',
      processingFailed:
        'Не удалось преобразовать JSON. Проверьте структуру и попробуйте уменьшить документ.',
      unknown: 'неизвестная ошибка',
    },
    howTitle: 'Как это работает',
    how:
      'Инструмент парсит JSON через JSON.parse в браузере и строит CSV с заголовками. Корневой объект становится одной строкой, массив — набором строк. Вложенные объекты и массивы раскрываются в колонки с путями вроде profile.name и tags[0]; значения экранируются по CSV-правилам.',
    whenTitle: 'Когда использовать',
    when:
      'JSON в CSV полезен, когда нужно быстро перенести API response, моковые данные, webhook payload или небольшой ETL-черновик в таблицу, BI-инструмент или spreadsheet.',
  },

  uuidGenerator: {
    controls: 'Настройки генерации',
    version: 'Версия',
    count: 'Количество',
    case: 'Регистр',
    hyphens: 'Дефисы',
    withHyphens: 'С дефисами',
    withoutHyphens: 'Без дефисов',
    generate: 'Сгенерировать',
    results: 'Результаты',
    copy: 'Копировать',
    copyAll: 'Копировать все',
    copied: 'Скопировано',
    noResults: 'Нажмите «Сгенерировать», чтобы получить UUID.',
    uppercase: 'Верхний регистр',
    lowercase: 'Нижний регистр',
    versionDescriptions: {
      v1: 'Время + случайный node',
      v4: 'Случайные UUID',
      v6: 'Время, сортируемый формат',
      v7: 'Unix-время + random',
    },
  },

  regexTester: {
    patternTitle: 'Регулярное выражение',
    pattern: 'Pattern',
    flags: 'Flags',
    patternPlaceholder: 'Например: order-(\\d+)',
    flagsPlaceholder: 'gim',
    run: 'Проверить',
    clear: 'Очистить',
    testText: 'Тестовый текст',
    textPlaceholder: 'Вставьте текст для проверки...',
    highlightedText: 'Подсветка совпадений',
    statsTitle: 'Результат',
    matches: 'Совпадения',
    groups: 'Группы',
    groupsTitle: 'Группы совпадений',
    match: 'Совпадение',
    noText: 'Текст появится здесь после ввода.',
    noMatches: 'Совпадений пока нет.',
    noGroups: 'У этого совпадения нет групп.',
    fixRegex: 'Исправьте регулярное выражение, чтобы увидеть группы.',
    emptyMatch: '(пустое совпадение)',
    emptyGroup: '(пусто)',
    copySummary: 'Копировать результат',
    copyShare: 'Копировать ссылку',
    copied: 'Скопировано',
    truncated: 'Показаны первые {limit} совпадений, чтобы страница оставалась отзывчивой.',
    errors: {
      emptyPattern: 'Введите регулярное выражение.',
      invalid: 'Некорректное регулярное выражение: {error}',
    },
  },

  jwtDecoder: {
    token: 'JWT токен',
    result: 'Header и payload',
    decode: 'Декодировать JWT',
    clear: 'Очистить',
    copy: 'Копировать JSON',
    copied: 'Скопировано',
    inputPlaceholder: 'Вставьте JWT: eyJhbGciOiJIUzI1NiIs...',
    outputPlaceholder: 'Декодированные header и payload появятся здесь...',
    inputAriaLabel: 'JWT для локального декодирования',
    outputAriaLabel: 'Декодированные header и payload JWT',
    signatureWarning: 'Важно: инструмент только декодирует содержимое. Подпись JWT не проверяется.',
    errors: {
      'invalid-format': 'Некорректный формат JWT. Ожидаются три сегмента header.payload.signature и непустая подпись. Для alg «none» подпись, наоборот, должна быть пустой.',
      'invalid-base64url': 'Один из сегментов JWT содержит некорректную Base64URL-строку.',
      'invalid-json': 'Header или payload после декодирования не является корректным UTF-8 JSON-объектом.',
    },
  },

  markdownEditor: {
    inputTitle: 'Markdown',
    previewTitle: 'Предпросмотр HTML',
    inputPlaceholder: '# Заголовок\n\nНачните писать **Markdown**…',
    inputAriaLabel: 'Markdown для локального предпросмотра',
    previewPlaceholder: 'Предпросмотр появится во время ввода Markdown.',
    previewPending: 'Обновляем предпросмотр…',
    copyMarkdown: 'Копировать Markdown',
    copyHtml: 'Копировать HTML',
    copied: 'Скопировано',
    downloadMarkdown: 'Скачать .md',
    downloadHtml: 'Скачать .html',
    clear: 'Очистить',
    words: 'Слов',
    headings: 'Заголовков',
    links: 'Ссылок',
    tables: 'Таблиц',
    flavorNote: 'CommonMark + GFM: документ до 256 КиБ в UTF-8, предпросмотр до 64 КиБ. На других площадках вид может отличаться.',
    rawHtmlWarning: 'Найден raw HTML: он намеренно исключён из предпросмотра и экспорта в HTML.',
    imageWarning: 'Изображения не загружаются и исключены из предпросмотра и экспорта в HTML, чтобы локальная обработка не создавала сетевые запросы.',
    sourceTooLarge: 'Markdown превышает общий лимит {limit} КиБ в UTF-8. Изменение отклонено, предыдущий текст сохранён.',
    previewTooLarge: 'Текст принят, но превышает лимит предпросмотра {limit} КиБ в UTF-8. Его можно скопировать и скачать как .md; для HTML уменьшите документ.',
    renderError: 'Не удалось построить предпросмотр. Исходный Markdown сохранён — попробуйте изменить проблемный фрагмент.',
    exportTitle: 'Markdown документ',
  },

  hashGenerator: {
    inputTitle: 'Исходный текст',
    outputTitle: 'Хэши',
    generate: 'Рассчитать хэши',
    generating: 'Расчёт…',
    clear: 'Очистить',
    copy: 'Копировать',
    copied: 'Скопировано',
    legacy: 'Устаревший',
    characters: 'Символов UTF-16',
    inputPlaceholder: 'Введите текст, для которого нужно рассчитать хэш…',
    inputAriaLabel: 'Текст для локального расчёта хэшей',
    outputPlaceholder: 'Нажмите «Рассчитать хэши»',
    utf8Note: 'Перед расчётом текст кодируется в UTF-8. Текст и полученные хэши не отправляются на сервер или в аналитику.',
    securityWarning: 'MD5 и SHA-1 показаны только для совместимости. Не используйте их для паролей, цифровых подписей или других задач безопасности.',
    error: 'Не удалось рассчитать хэши в этом браузере. Проверьте поддержку Web Crypto и повторите попытку.',
  },

  cronGenerator: {
    expressionTitle: 'Cron expression',
    expressionLabel: '5 полей: minute hour day month weekday',
    parse: 'Разобрать',
    reset: 'Сбросить',
    copy: 'Копировать',
    copied: 'Скопировано',
    builderTitle: 'Собрать расписание',
    applyBuilder: 'Применить',
    humanTitle: 'Описание расписания',
    nextRunsTitle: 'Ближайшие запуски',
    fixExpression: 'Исправьте cron-выражение, чтобы увидеть расписание.',
    noRuns: 'Ближайшие запуски появятся после корректного выражения.',
    timezoneCaveat:
      'Примеры рассчитаны в часовом поясе вашего браузера. Сервер, CI или Kubernetes CronJob могут использовать другой timezone.',
    daySemantics:
      'Если day и weekday оба заданы не через *, запуск считается при совпадении любого из этих двух полей.',
    stepPlaceholder: 'Шаг, например 15',
    rangeStart: 'От',
    rangeEnd: 'До',
    fields: {
      minute: 'Минута',
      hour: 'Час',
      day: 'День месяца',
      month: 'Месяц',
      weekday: 'День недели',
    },
    builderModes: {
      any: 'Любой',
      specific: 'Точное значение',
      every: 'Каждые N',
      range: 'Диапазон',
    },
    builderPlaceholders: {
      minute: '0, 15 или 0,30',
      hour: '9 или 9,18',
      day: '1 или 1,15',
      month: '1 или JAN',
      weekday: '1 или MON',
    },
    summary: {
      any: 'Любой {field}',
      every: 'Каждые {step} для поля {field}',
      range: '{field}: диапазон {values}',
      specific: '{field}: {values}',
    },
    months: [
      'январь',
      'февраль',
      'март',
      'апрель',
      'май',
      'июнь',
      'июль',
      'август',
      'сентябрь',
      'октябрь',
      'ноябрь',
      'декабрь',
    ],
    weekdays: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    errors: {
      fieldCount: 'Ожидается 5 полей cron, сейчас: {count}.',
      emptyField: 'Поле не должно быть пустым.',
      emptyPart: 'Часть поля не должна быть пустой.',
      invalidValue: 'Некорректное значение «{value}».',
      outOfRange: 'Значение «{value}» вне диапазона {min}-{max}.',
      invalidStep: 'Некорректный шаг «{step}».',
      invalidRange: 'Некорректный диапазон «{range}».',
      noRuns: 'Не удалось найти ближайшие запуски за 5 лет.',
    },
  },

  textDiff: {
    original: 'Исходный текст',
    modified: 'Изменённый текст',
    originalPlaceholder: 'Вставьте исходный код, конфиг или текст…',
    modifiedPlaceholder: 'Вставьте изменённую версию…',
    options: 'Параметры сравнения',
    ignoreCase: 'Игнорировать регистр',
    ignoreWhitespace: 'Игнорировать пробелы по краям строк',
    limit: 'До {size} КБ и {lines} строк на каждую сторону',
    compare: 'Сравнить',
    comparing: 'Сравниваем…',
    swap: 'Поменять местами',
    sample: 'Пример',
    clear: 'Очистить',
    result: 'Результат сравнения',
    resultAria: 'Построчный результат сравнения текста',
    summary: 'Добавлено строк: {added}, удалено: {removed}',
    identical: 'Тексты совпадают с учётом выбранных параметров.',
    copy: 'Копировать diff',
    copied: 'Скопировано',
    collapsed: 'Скрыто неизменённых строк: {count}',
    errors: {
      bytes: 'Один из текстов превышает лимит 500 КБ. Сократите его и попробуйте снова.',
      lines: 'Один из текстов превышает лимит 5 000 строк. Сократите его и попробуйте снова.',
      timeout: 'Сравнение заняло слишком много времени. Сократите тексты или сравните более похожие фрагменты.',
      failed: 'Не удалось сравнить тексты. Проверьте ввод и попробуйте снова.',
    },
  },

  blog: {
    breadcrumb: 'Блог',
    title: 'Блог devdeck',
    description:
      'Практические заметки про JSON, YAML, Base64, UUID, регулярные выражения и локальные инструменты разработчика.',
    languageAria: 'Язык статей',
    postLanguageAria: 'Язык статьи',
    empty: 'На этом языке пока нет записей.',
    notFoundTitle: 'Пост не найден',
    notFoundDescription: 'Такой заметки в блоге devdeck нет или ссылка устарела.',
    relatedTools: 'Связанные инструменты',
    localeName: {
      ru: 'Русский',
      en: 'English',
    },
  },

  seo: {
    indexTitle: 'Инструменты разработчика онлайн бесплатно — devdeck.ru',
    indexDescription:
      'Бесплатные локальные инструменты разработчика: JSON formatter, YAML formatter, XML formatter, Base64, HTML entities, UUID generator, cron generator и regex tester.',
    blogTitle: 'Блог devdeck - заметки про инструменты разработчика',
    blogDescription:
      'Практические заметки про JSON, YAML, Base64, UUID, regex и локальную обработку developer payload в браузере.',
  },
}

export type Translations = typeof ruTranslations
